module.exports = __webpack_public_path__ + "img/canada-logo-icon.1c158dc2.png";